"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgCreateVaultTypeResponse = exports.MsgCreateVaultType = exports.MsgRemoveDebtResponse = exports.MsgRemoveDebt = exports.MsgAddDebtResponse = exports.MsgAddDebt = exports.MsgRemoveCollateralResponse = exports.MsgRemoveCollateral = exports.MsgAddCollateralResponse = exports.MsgAddCollateral = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "Switcheo.carbon.cdp";
const baseMsgAddCollateral = {
    creator: "",
    vaultTypeId: long_1.default.UZERO,
    amount: "",
};
exports.MsgAddCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.vaultTypeId.isZero()) {
            writer.uint32(16).uint64(message.vaultTypeId);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.vaultTypeId = reader.uint64();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromString(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.vaultTypeId !== undefined &&
            (obj.vaultTypeId = (message.vaultTypeId || long_1.default.UZERO).toString());
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgAddCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromValue(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgAddCollateralResponse = {};
exports.MsgAddCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAddCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAddCollateralResponse);
        return message;
    },
};
const baseMsgRemoveCollateral = {
    creator: "",
    vaultTypeId: long_1.default.UZERO,
    amount: "",
};
exports.MsgRemoveCollateral = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.vaultTypeId.isZero()) {
            writer.uint32(16).uint64(message.vaultTypeId);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveCollateral);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.vaultTypeId = reader.uint64();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveCollateral);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromString(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.vaultTypeId !== undefined &&
            (obj.vaultTypeId = (message.vaultTypeId || long_1.default.UZERO).toString());
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveCollateral);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromValue(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveCollateralResponse = {};
exports.MsgRemoveCollateralResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveCollateralResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveCollateralResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveCollateralResponse);
        return message;
    },
};
const baseMsgAddDebt = {
    creator: "",
    vaultTypeId: long_1.default.UZERO,
    amount: "",
};
exports.MsgAddDebt = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.vaultTypeId.isZero()) {
            writer.uint32(16).uint64(message.vaultTypeId);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddDebt);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.vaultTypeId = reader.uint64();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgAddDebt);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromString(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.vaultTypeId !== undefined &&
            (obj.vaultTypeId = (message.vaultTypeId || long_1.default.UZERO).toString());
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgAddDebt);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromValue(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgAddDebtResponse = {};
exports.MsgAddDebtResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgAddDebtResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgAddDebtResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgAddDebtResponse);
        return message;
    },
};
const baseMsgRemoveDebt = {
    creator: "",
    vaultTypeId: long_1.default.UZERO,
    amount: "",
};
exports.MsgRemoveDebt = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.vaultTypeId.isZero()) {
            writer.uint32(16).uint64(message.vaultTypeId);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveDebt);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.vaultTypeId = reader.uint64();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgRemoveDebt);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromString(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.vaultTypeId !== undefined &&
            (obj.vaultTypeId = (message.vaultTypeId || long_1.default.UZERO).toString());
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgRemoveDebt);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.vaultTypeId =
            object.vaultTypeId !== undefined && object.vaultTypeId !== null
                ? long_1.default.fromValue(object.vaultTypeId)
                : long_1.default.UZERO;
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgRemoveDebtResponse = {};
exports.MsgRemoveDebtResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgRemoveDebtResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgRemoveDebtResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgRemoveDebtResponse);
        return message;
    },
};
const baseMsgCreateVaultType = {
    creator: "",
    collateralDenom: "",
    debtDenom: "",
    collateralizationRatio: "",
};
exports.MsgCreateVaultType = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(18).string(message.collateralDenom);
        }
        if (message.debtDenom !== "") {
            writer.uint32(26).string(message.debtDenom);
        }
        if (message.collateralizationRatio !== "") {
            writer.uint32(34).string(message.collateralizationRatio);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateVaultType);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.collateralDenom = reader.string();
                    break;
                case 3:
                    message.debtDenom = reader.string();
                    break;
                case 4:
                    message.collateralizationRatio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateVaultType);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.collateralizationRatio =
            object.collateralizationRatio !== undefined &&
                object.collateralizationRatio !== null
                ? String(object.collateralizationRatio)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.collateralizationRatio !== undefined &&
            (obj.collateralizationRatio = message.collateralizationRatio);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseMsgCreateVaultType);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.collateralDenom = (_b = object.collateralDenom) !== null && _b !== void 0 ? _b : "";
        message.debtDenom = (_c = object.debtDenom) !== null && _c !== void 0 ? _c : "";
        message.collateralizationRatio = (_d = object.collateralizationRatio) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseMsgCreateVaultTypeResponse = {};
exports.MsgCreateVaultTypeResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateVaultTypeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateVaultTypeResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateVaultTypeResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.HandleMsgAddCollateral = this.HandleMsgAddCollateral.bind(this);
        this.HandleMsgRemoveCollateral = this.HandleMsgRemoveCollateral.bind(this);
        this.HandleMsgAddDebt = this.HandleMsgAddDebt.bind(this);
        this.HandleMsgRemoveDebt = this.HandleMsgRemoveDebt.bind(this);
        this.HandleMsgCreateVaultType = this.HandleMsgCreateVaultType.bind(this);
    }
    HandleMsgAddCollateral(request) {
        const data = exports.MsgAddCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "HandleMsgAddCollateral", data);
        return promise.then((data) => exports.MsgAddCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleMsgRemoveCollateral(request) {
        const data = exports.MsgRemoveCollateral.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "HandleMsgRemoveCollateral", data);
        return promise.then((data) => exports.MsgRemoveCollateralResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleMsgAddDebt(request) {
        const data = exports.MsgAddDebt.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "HandleMsgAddDebt", data);
        return promise.then((data) => exports.MsgAddDebtResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleMsgRemoveDebt(request) {
        const data = exports.MsgRemoveDebt.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "HandleMsgRemoveDebt", data);
        return promise.then((data) => exports.MsgRemoveDebtResponse.decode(new minimal_1.default.Reader(data)));
    }
    HandleMsgCreateVaultType(request) {
        const data = exports.MsgCreateVaultType.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.cdp.Msg", "HandleMsgCreateVaultType", data);
        return promise.then((data) => exports.MsgCreateVaultTypeResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
